export const state = {
  budgetsystem: null,
  budgetsystems: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/budgetsystem/state.js